<div class="eula-container">
    <h1>END-USER LICENSE AGREEMENT (EULA)</h1>

    <p><strong>Last Updated: [Date]</strong></p>

    <p>
        This End-User License Agreement (“Agreement”) is a legal agreement between you (“User”) and 
        <strong>[Your Company Name]</strong> (“Company”) for the use of <strong>Service Galaxy</strong> 
        (“Software”), including its integration with QuickBooks for item and invoice synchronization. 
        By installing, accessing, or using the Software, you agree to be bound by the terms of this Agreement. 
        If you do not agree to these terms, do not install or use the Software.
    </p>

    <hr class="divider">

    <h2>1. LICENSE GRANT</h2>
    <p>Company grants the User a limited, non-exclusive, non-transferable, and revocable license to use the Software
        solely for business purposes, subject to the terms and conditions of this Agreement.</p>

    <hr class="divider">

    <h2>2. RESTRICTIONS</h2>
    <p><strong>User shall not:</strong></p>
    <ul>
        <li>Modify, distribute, sublicense, or reverse-engineer the Software.</li>
        <li>Use the Software for unlawful purposes.</li>
        <li>Access QuickBooks data in violation of Intuit’s terms of service.</li>
    </ul>

    <hr class="divider">

    <h2>3. OWNERSHIP & INTELLECTUAL PROPERTY</h2>
    <p>The Software and all related intellectual property rights remain the exclusive property of the Company. 
       This Agreement does not grant the User any ownership rights.</p>

    <hr class="divider">

    <h2>4. INTEGRATION WITH QUICKBOOKS</h2>
    <ol>
        <li><strong>Overview:</strong> The Software integrates with QuickBooks to sync items and invoices, allowing seamless data transfer between Service Galaxy and QuickBooks.</li>
        <li><strong>Credentials:</strong> To enable integration, the User must provide a QuickBooks Client ID and Client Secret Key. By providing these credentials, you authorize the Software to access and transfer data between QuickBooks and Service Galaxy.</li>
        <li><strong>User Responsibility:</strong> You are solely responsible for safeguarding your QuickBooks Client ID and Client Secret Key and preventing unauthorized access to them.</li>
        <li><strong>Compliance:</strong> Users must comply with QuickBooks' terms of service and ensure proper authorization when connecting their accounts.</li>
        <li><strong>Liability:</strong> The Company is not liable for discrepancies, data loss, or QuickBooks API changes affecting synchronization. The User is responsible for verifying the accuracy and completeness of synced data.</li>
    </ol>

    <hr class="divider">

    <h2>5. DISCLAIMER OF WARRANTIES</h2>
    <p>The Software is provided “as is” without any warranties, express or implied. The Company does not guarantee error-free operation or uninterrupted service.</p>

    <hr class="divider">

    <h2>6. LIMITATION OF LIABILITY</h2>
    <p>Company shall not be liable for any indirect, incidental, special, or consequential damages arising from the use or inability to use the Software, including but not limited to data synchronization errors with QuickBooks.</p>

    <hr class="divider">

    <h2>7. TERMINATION</h2>
    <p>This Agreement is effective until terminated. <strong>Company</strong> may revoke the license at any time if the User violates any terms. Upon termination, the User must cease all use of the Software.</p>

    <hr class="divider">

    <h2>8. GOVERNING LAW</h2>
    <p>This Agreement shall be governed by and construed in accordance with the laws of <strong>[Your Jurisdiction]</strong>.</p>

    <hr class="divider">

    <h2>9. CONTACT INFORMATION</h2>
    <p>For any questions regarding this Agreement, please contact:<br>
        <strong>[Your Company Name]</strong><br>
        <strong>[Your Contact Email]</strong><br>
        <strong>[Your Website]</strong>
    </p>

    <hr class="divider">

    <p>By using the Software, you acknowledge that you have read and understood this Agreement and agree to be bound by its terms.</p>
</div>
